var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-container',{staticClass:"az-container-mobile"},[_c('relatorio-painel-listagem-tabela',{attrs:{"items":_vm.relatorios},on:{"acessar-relatorio":_vm.acessarRelatorio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }